<template>
	<div>
		<div style="font-size: 20px; margin-top: 40px; margin-left: 40px; font-weight: 600;">工资拆分汇总表</div>
		<el-row style="margin-top: 9px;">
			<div style="height: 750px; background-color: #FFFFFF; margin: 0px 40px; border: 1px solid #eaebed;">

				<el-row style="padding-left: 46px; padding-top: 40px;">

					<el-col :span="7">
						<span>组织架构</span>
						<el-cascader v-model="condition.organize_ids" collapse-tags style="margin-left:10px;width:300px"
						:props="props" clearable></el-cascader>
					</el-col>

					<el-col :span="5">
						<span>日期</span>
						<el-date-picker v-model="condition.years_date" type="month" placeholder="请选择"
							value-format="yyyy-MM" style="margin-left: 10px;">
						</el-date-picker>
					</el-col>
					<el-col :span="4">
						<span>拆分状态 </span>
						<el-select v-model="condition.splitState" style="margin-left:10px;width:160px" placeholder="请选择拆分状态" clearable>
							<el-option value="2" label="已拆分"></el-option>
							<el-option value="1" label="未拆分"></el-option>
						</el-select>
					</el-col>

					<el-col :span="10">
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="Find">
							查询</el-button>
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="reception(null)">
							接收</el-button>
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="send(null)">
							退回</el-button>
						<el-button
							style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
							@click="resolutions(null)">
							拆分</el-button>
					</el-col>

					<el-col :span="4">
							
							<download-excel class="export-excel-wrapper"
								:fields="download_excel" title="工资拆分汇总表"
									name="工资拆分汇总表.xls"
								:fetch="ExportForm" >
								<el-button
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
							
						</el-col>
				</el-row>
				<el-row style="margin: 0px 2%; margin-top: 20px;">
					<el-row style="margin-top: 10px;">
						<el-table :header-cell-style="{background:'#d3eae2',color:'#000000'}" :border="true"
							:row-class-name="tableRowClassName" ref="table" :data="tableData"
							:summary-method="getSummaries"  tooltip-effect="dark" max-height="600"
							style="width: 100%;max-height: 600px" @selection-change="handleSelectionChange" :expand-row-keys="expands">
							<el-table-column type="expand">
								<template slot-scope="scope">
									<el-table :header-cell-style="{background:'#edeff1',color:'#000000'}" :border="true"
										ref="table" :data="scope.row.detailsList" :summary-method="getSummaries"
										height="400" tooltip-effect="dark" style="width: 100%;"
										@selection-change="handleSelectionChanges"
										v-show="scope.row.detailsList.length>0">
										<el-table-column type="selection" align="center" width="55">
										</el-table-column>
										<el-table-column align="center" label="序号" width="50">
											<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
										</el-table-column>
										<!-- <el-table-column align="center"
										                              label="员工姓名"
										                              width="180">
										                 <template slot-scope="props">
										                               <span>{{props.row.staff_name}}</span>
										                             </template>
										             </el-table-column> -->

										<el-table-column prop="staff_name" align="center" label="员工姓名" width="100">
										</el-table-column>
										<el-table-column prop="after_tax_paid_salary" align="center" label="实发工资(税后)"
											width="120"></el-table-column>
										<el-table-column prop="receiving_method" align="center" label="领取方式" width="80">
										</el-table-column>
										<el-table-column prop="bank_card_number" align="center" label="银行卡号"
											width="150"></el-table-column>
										<el-table-column prop="cardholder_name" align="center" label="持卡人姓名"
											width="100"></el-table-column>
										<el-table-column prop="entry_name" align="center" label="项目名称" width="200">
										</el-table-column>
										<el-table-column prop="id_card" align="center" label="身份证号" width="170">
										</el-table-column>
										<el-table-column prop="telephone_number" align="center" label="电话号" width="110">
										</el-table-column>
										<el-table-column prop="gender" align="center" label="性别" width="60">
										</el-table-column>
										<el-table-column prop="post_name" align="center" label="岗位名称" width="130">
										</el-table-column>
										<el-table-column align="center" label="状态" width="120">
											<template slot-scope="scope">
												<img src="../../../assets/未发放.png"
														v-show="scope.row.spare5 === '0'" />
													<img src="../../../assets/待接收.png"
														v-show="scope.row.spare5 === '1'" />
													<img src="../../../assets/待发放.png"
														v-show="scope.row.spare5 === '2'" />
													<img src="../../../assets/已拆分.png"
														v-show="scope.row.spare5 === '3'" />
													<img src="../../../assets/发放成功.png"
														v-show="scope.row.spare5 === '4'" />
													<img src="../../../assets/发放失败.png"
														v-show="scope.row.spare5 === '5'" />
													<img src="../../../assets/已代发.png"
														v-show="scope.row.spare5 === '6'" />
													<img src="../../../assets/已代发.png"
														v-show="scope.row.spare5 === '7'" />
											</template>
										</el-table-column>
										<!-- <el-table-column align="center" label="操作" width="120">
											<template slot-scope="scope">

											</template>
										</el-table-column> -->
									</el-table>
								</template>
							</el-table-column>
							<el-table-column type="selection" align="center" width="55">
							</el-table-column>
							<el-table-column align="center" label="序号" width="50">
								<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
							</el-table-column>
							<el-table-column prop="release_date" align="center" label="发放日期" width="150">
							</el-table-column>
							<el-table-column prop="superior_name" align="center" label="架构" width="100">
								</el-table-column>
							<el-table-column prop="organize_name" align="center" label="项目名称" width="200">
							</el-table-column>
							<el-table-column prop="paid_amount" align="center" label="实领金额" width="80">
							</el-table-column>
							<el-table-column prop="cash" align="center" label="现金/待开" width="100"></el-table-column>
							<el-table-column prop="bank_card" align="center" label="银行卡" width="200"></el-table-column>
							<!-- <el-table-column prop="bankuai" align="center" label="薪酬审批" width="80"></el-table-column> -->
							<el-table-column v-for="(item, index) in tableTitle" align="center" :label="item.bank_name"
								:key="index">
								<el-table-column v-for="(a,b) in item.grantList" :label="a.split_name" :key="b"
									align="center" width="100">
									<template slot-scope="scope">
										{{bank(scope.row.detailsMap, item.bank_name, b, a.split_name)}}
										<!-- <button @click="bank(scope.row.detailsMap, item.bank_name, b, a.split_name)">111</button> -->
									</template>
								</el-table-column>

							</el-table-column>
							<el-table-column align="center" label="五险">
								<el-table-column v-for="(item,index) in wxList" align="center"
									:label="item.partner_abbreviation" width="120" :key="index">
									<template slot-scope="scope">
										{{wuxian(scope.row.partnerMap,'五险', index, item.partner_abbreviation)}}
									</template>
								</el-table-column>
							</el-table-column>
							<el-table-column v-for="(item,index) in cfzhList" align="center" :label="item.data + '汇总'"
								width="120" :key="index">
								<template slot-scope="scope">
									{{zhanghu(scope.row.salaryMap, item.data)}}
								</template>
							</el-table-column>
							<el-table-column prop="partnerTotal" align="center" label="五险汇总" width="120">
							</el-table-column>
							<el-table-column prop="project_name" align="center" label="合计" width="80"></el-table-column>
							<el-table-column prop="post_name" align="center" label="发放状态">
								<template slot-scope="scope">
									<img src="../../../assets/stateImg/状态_未发放.png"
										v-show="scope.row.reviewer_state === '0'" />
									<img src="../../../assets/stateImg/状态_已发放.png"
										v-show="scope.row.reviewer_state === '1'" />
								</template>
							</el-table-column>
						</el-table>
					</el-row>
					<el-row style="margin-top: 10px; text-align: center;">
				        <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
				            layout=" prev, pager, next, jumper" :total="total">
				        </el-pagination>
				    </el-row>
				</el-row>

			</div>
		</el-row>
	</div>
</template>

<script>
	import axios from "axios";
	export default {
		components: {},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//列表相关
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],

				//页面相关
				dialogVisible: false,
				tableTitle: [],
				cfzhList: [],
				wxList: [],

				//条件
				condition: {
					organize_ids: [],
					years_date: this.$globals.getNowTimes(),
					splitState:'',
				},

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},
				//组织架构数据
				organizeList: [],

				//详情
				from: {
					id: '',
					bank_id: '',
				},

				download_excel: {
					"项目名称": "organize_name",
					"工资归属月": "reviewer_date",
					"发放日期": "issue_date",
					"实发金额": "paid_amount",
					"现金": "cash",
					"银行卡": "bank_card",
					"薪酬制作人": "reviewer_name",
					"代发公司": "agency_company",
					"乙方名头": "name_party_B",
					
				},

				//复选框ids
				ids: [],
				idsson:[],
			};
		},
		computed: {
			//表格高度计算函数 因为动态表格影响高度
			// headerHeight() {
			// 	if (this.tableTitle.length > 0) {
			// 		return 'calc(500px + 50px)'
			// 	}
			// 	return '100%'
			// }
		},
		methods: {
			
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.organize_id);
				});
			},
			handleSelectionChanges(a) {
				this.idsson = [];
				a.forEach(item => {
					this.idsson.push(item.id);
				});
			},
			//获取表头
			async initializeTableTitle() {
				var tableTitle = await this.$globals.AxiosPost("/GrantProportion/selectProportion", {});
				this.tableTitle = tableTitle.data;
			},
			//查询
			Find() {
				this.initializeTableTitle();
				this.resolution();
				this.insurance();
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})
				const url = this.$globals.http + "DistributionSummary/selectSummaryAlls";
				axios.post(url, {
					page_num: this.page_num,
					page_size: this.page_size,
					organizeIds:organize_ids,
					splitState:this.condition.splitState,
					years_date: this.condition.years_date + '-01',
					applicant_id: this.$globals.user.staff_id,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},

			//导表
			async ExportForm() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'DistributionSummary/getSummarys';
				var record = {
					organizeIds:organize_ids,
					splitState:this.condition.splitState,
					years_date: this.condition.years_date + '-01',
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if ( data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					}
				}
			},

			//接收
			async reception(e) {
				var ids;
				var idsson;
				if (e === null || e === "" || e === undefined) {
					ids = this.ids;
					idsson = this.idsson;
				} else {
					ids = [e];
				}
				
				var url = "/DistributionSummary/ReceiveOn";
				var record = {
					organize_ids: ids,
					years_date: this.condition.years_date + '-01',
					details_ids: idsson
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
				this.Find();
			},
			//退回
			async send(e) {
				var ids;
				var idsson;
				if (e === null || e === "" || e === undefined) {
					ids = this.ids;
					idsson = this.idsson;
				} else {
					ids = [e];
				}
				
				var url = "/DistributionSummary/ReturnOn";
				var record = {
					organize_ids: ids,
					years_date: this.condition.years_date + '-01',
					details_ids: idsson
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
				this.Find();
			},
			//拆分
			async resolutions(e) {
				var ids;
				var idsson;
				if (e === null || e === "" || e === undefined) {
					ids = this.ids;
					idsson = this.idsson;
				} else {
					ids = [e];
				}
				
				var url = "/DistributionSummary/oneKeySplit";
				var record = {
					organize_ids: ids,
					years_date: this.condition.years_date + '-01',
					details_ids: idsson
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
				this.Find();
			},
			// 拆分账户
			async resolution() {
				var cfzhList = await this.$globals.AxiosPost('dictionaries/selectFind', {
					data_grouping: 'split_account'
				});
				this.cfzhList = cfzhList.data;
			},
			//五险
			async insurance() {
				var wxList = await this.$globals.AxiosPost('partner/SelectAll', {});
				this.wxList = wxList.data.list;
			},
			//子表没数据不展示折叠箭头
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.detailsList.length == 0) {
					return 'row-expand-cover';
				} else {
					return '';
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val
				this.Find();
			},
			// 表头
			bank(e1, e2, e3, e4) {
				// debugger
				// console.log(e1,'11')
				// console.log(e2,'22')
				// console.log(e3)
				// console.log(e4)
				// console.log(e1[e2][e3])
				// console.log(e1[e2][e3][e4])
				if (e1 == undefined || e1 == null || e1 == '') {
					return '';
				}
				if (e1[e2] == undefined || e1[e2] == null || e1[e2] == '') {
					return '';
				}
				if (e1[e2][e3] == undefined || e1[e2][e3] == null || e1[e2][e3] == '') {
					return '';
				}
				if (e1[e2][e3][e4] == undefined || e1[e2][e3][e4] == null || e1[e2][e3][e4] == '') {
					return '';
				}
				return e1[e2][e3][e4];
			},
			zhanghu(e1, e2) {
				if (e1 == undefined || e1 == null || e1 == '') {
					return '';
				}
				if (e1[e2] == undefined || e1[e2] == null || e1[e2] == '') {
					return '';
				}
				return e1[e2];
			},
			wuxian(e1, e2, e3, e4) {
				
				if (e1 == undefined || e1 == null || e1 == '') {
					return '';
				}
				if (e1[e2] == undefined || e1[e2] == null || e1[e2] == '') {
					return '';
				}
				if (e1[e2][e3] == undefined || e1[e2][e3] == null || e1[e2][e3] == '') {
					return '';
				}
				if (e1[e2][e3][e4] == undefined || e1[e2][e3][e4] == null || e1[e2][e3][e4] == '') {
					return '';
				}
				return e1[e2][e3][e4];
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
					id: this.condition.project_id
				});
				this.organizeList = this.getTreeData(organizeList.data);
			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.organizeFind();
			this.Find();

		}
	}
</script>

<style scoped="scoped">
	>>>.el-button:hover {
		background-color: #FFFFFF;
	}

	>>>.el-button:focus {
		background-color: #FFFFFF;
	}

	>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006E4B;
	}

	>>>.el-input__inner:focus {
		border-color: #006E4B;
	}

	>>>.el-select .el-input.is-focus .el-input__inner {
		border-color: #006E4B;
	}

	>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	>>>.el-checkbox__inner:hover {
		border-color: #006E4B;
	}

	>>>.row-expand-cover .el-table__expand-column .el-icon {
		visibility: hidden;
	}
</style>



// WEBPACK FOOTER //
// GzcfHz.vue?28539760